import type {ReactElement} from 'react';
import React from 'react';
import {getCurrentPage} from '@Components/poster-editor/poster-editor-reducer';
import {BackgroundTypeName} from '@PosterWhiteboard/page/background/background.class';
import {BaseItemVibranceOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-item-vibrance-option';
import {useAppSelector} from '@/hooks';

export function ImageBgVibranceOption(): ReactElement | null {
  const currentPageObject = useAppSelector(getCurrentPage);
  const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();

  if (!currentPageObject) {
    return null;
  }

  if (currentPageObject.background.details.type !== BackgroundTypeName.IMAGE) {
    return null;
  }

  const updateVibrance = (vibrance: number, undoable?: boolean): void => {
    void currentPage?.background.updateFromObject(
      {
        details: {
          imageBackgroundItemObject: {
            effects: {
              vibrance,
            },
          },
        },
      },
      {
        undoable,
      }
    );
  };

  return <BaseItemVibranceOption vibrance={currentPageObject.background.details.imageBackgroundItemObject.effects.vibrance} updateVibrance={updateVibrance} />;
}
